import { Base, Container, Grid, Media, Parse, Section } from '@/components/Core'
import { Button } from '@/components/Ui'
import { Lib } from '@/types'
import clsx from 'clsx'
import { readFragment } from 'gql.tada'
import { memo } from 'react'
import SectionTextFragment from './query'

export interface SectionTextProps {
  data: Lib.FragmentOf<typeof SectionTextFragment>
}

export type SectionTextData = Lib.FragmentOf<typeof SectionTextFragment> & {
  _modelApiKey: 'section_text'
  __typename: 'SectionTextRecord'
  id: string
}

const SectionText = ({ data }: SectionTextProps) => {
  const d = readFragment(SectionTextFragment, data)

  return (
    <Section
      className={clsx(
        'py-vertical-main',
        d?.background === 'gray' && 'bg-neutral-300'
      )}
      sectionName={d._modelApiKey}
      mainWrapper={false}
      anim="section-fade-in"
    >
      <Container>
        <Grid>
          <div className="gap-md col-span-12 flex flex-col lg:col-span-4 lg:col-start-2">
            {d?.title && (
              <h2 className="hyphens">
                <Parse html={d.title} excludeTags={['p']} />
              </h2>
            )}
            {d?.titleSmall && (
              <Base as={d?.title ? 'h3' : 'h2'} className="h4">
                {d?.titleSmall}
              </Base>
            )}
          </div>
          <div className="gap-vertical-small col-span-12 flex flex-col lg:col-span-6">
            {d.titleRight && (
              <div className={'text-style-large'}>{d.titleRight}</div>
            )}
            {d.content && (
              <div className={'prose max-w-full'}>
                <Parse html={d.content} />
              </div>
            )}

            {d.media && <Media data={d.media} ar={'16x9'} className="w-full" />}

            {d?.linkList.length > 0 && (
              <div className="">
                {d.linkList.map((link, index) => (
                  <div key={index}>
                    <Button data={link} variant="text" />
                  </div>
                ))}
              </div>
            )}

            {d?.buttons.length > 0 && (
              <div className="flex flex-wrap gap-2">
                {d.buttons.map((button, index) => (
                  <Button data={button} key={index} />
                ))}
              </div>
            )}
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default memo(SectionText)
